"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const Swiper = require("swiper/react");
const TileGroupSliderNav_1 = require("../ui/TileGroupSliderNav");
const Tile_1 = require("../../../Tile");
const useTileGroupSliding_1 = require("../../useTileGroupSliding");
const TileGroupSlider = ({ items, dictionary, defaultImageType, tileType, tileShape, totalItems, groupType, isDescriptionExpandable, }) => {
    const { slides, slidesCount, activeSlideIndex, setActiveSlideIndex } = (0, useTileGroupSliding_1.useTileGroupSliding)(items);
    const swiperRef = React.useRef(null);
    React.useEffect(() => {
        swiperRef.current.slideToLoop(0);
        setActiveSlideIndex(0);
    }, [slidesCount]);
    const handleSlideChange = swiper => {
        setActiveSlideIndex(swiper.realIndex);
    };
    const handleSlideNav = React.useCallback((slideIndex) => {
        swiperRef.current.slideToLoop(slideIndex);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Swiper.Swiper, { spaceBetween: 15, slidesPerView: 1, loop: true, grabCursor: true, runCallbacksOnInit: true, onSwiper: swiper => {
                    swiperRef.current = swiper;
                }, onActiveIndexChange: handleSlideChange, children: slides.map((items, index) => ((0, jsx_runtime_1.jsx)(Swiper.SwiperSlide, { children: (0, jsx_runtime_1.jsx)(Tile_1.TileList, { items: items, dictionary: dictionary, defaultImageType: defaultImageType, tileType: tileType, tileShape: tileShape, totalItems: totalItems, groupType: groupType, isDescriptionExpandable: isDescriptionExpandable }) }, index))) }), slidesCount > 1 && ((0, jsx_runtime_1.jsx)(TileGroupSliderNav_1.default, { dictionary: dictionary, slidesCount: slidesCount, activeSlideIndex: activeSlideIndex, handleSlideNav: handleSlideNav }))] }));
};
exports.default = TileGroupSlider;
